import { ParagraphFormat } from "./ParagraphFormat";
import { RequestHelper, CallbackType } from "./helper/module";

export class TextChar  {
    //#region properties
    /** @type {any} */
    #txTextChar;
    get txTextChar() { return this.#txTextChar; }

    /** @type {any} */
    #bounds;
    get bounds() { return this.#bounds; }
    /** @type {string=} */
    #char;
    get char() { return this.#char; }

    //#endregion

    /**
     * Wrapper für TXTextControl.TextChar
     * @param {!any} txTextChar 
     */
    constructor(txTextChar) {
        this.#txTextChar = txTextChar;
        this.#bindCallbacks();
    }

    /**
     * binding callback functions
     */
    #bindCallbacks() {
        this.#txTextChar.getBounds = this.#txTextChar.getBounds.bind(this.#txTextChar);
        this.#txTextChar.getChar = this.#txTextChar.getChar.bind(this.#txTextChar);
    }

    //#region getter
    /**
     * @returns {Promise<any>}
     */
    async getBounds() {
        if (this.#bounds == null || typeof this.#bounds === 'undefined') {
            let result = await RequestHelper.Promise(this.txTextChar.getBounds,
                CallbackType.RequestRectangleCallback,
                CallbackType.ErrorCallback);
            this.#bounds = result;
        }
        return /** @type {any} */(this.#bounds);
    }

    /**
     * @returns {Promise<string>}
     */
    async getChar() {
        if (this.#char == null || typeof this.#char === 'undefined') {
            let result = await RequestHelper.Promise(this.txTextChar.getChar,
                CallbackType.RequestStringCallback,
                CallbackType.ErrorCallback);
            this.#char = result;
        }
        return /** @type {string} */(this.#char);
    }
    //#endregion
 
}